module.exports = __webpack_public_path__ + "static/media/2.93dac3f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/Guide/icon/2.svg
// module id = 6600
// module chunks = 0